import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  main: {
    padding: "100px 0px",
    width: "80%",
    margin: "auto",
    height: "100vh",

    [theme.breakpoints.down("xl")]: {
      padding: "140px 0px",
      height: "fit-content",
    },

    [theme.breakpoints.down("md")]: {
      padding: "75px 0px",
      width: "100%",
    },

    "& .mynameis": {
      color: theme.palette.primary.main,
      fontFamily: "SFMono",
      fontWeight: "800",
      lineHeight: "1.1",
      fontSize: "24px",
      marginBottom: "30px",

      [theme.breakpoints.down("xl")]: {
        fontSize: "20px",
        marginBottom: "30px",
      },

      [theme.breakpoints.down("md")]: {
        marginBottom: "40px",
      },
    },
    "& h1": {
      fontSize: "100px",
      fontWeight: "500",
      lineHeight: "1.1",
      margin: "0px",

      [theme.breakpoints.down("xl")]: {
        fontSize: "50px",   //size role
      },

      [theme.breakpoints.down("md")]: {
        fontSize: "35px",
      },
    },
    "& .name": {
      color: theme.palette.text.light,
      fontSize: "90px",
      [theme.breakpoints.down("md")]: {
        fontSize: "70px",
        marginBottom: "30px",
      },
    },
    "& .role": {
      color: theme.palette.text.dark,
      height: "100px",

      [theme.breakpoints.down("xl")]: {
        height: "80px",
      },

      [theme.breakpoints.down("md")]: {
        height: "100px",
      },
    },
    "& .description": {
      maxWidth: "900px",
      fontWeight: "400",
      fontSize: "24px",
      lineHeight: "1.4",
      color: theme.palette.text.dark,
      textShadow: "0px 0px 1px #8892b0",

      [theme.breakpoints.down("xl")]: {
        fontSize: "19px",
        maxWidth: "900px",
      },

      [theme.breakpoints.down("md")]: {
        textAlign: "justify",
      },

      "& .important": {
        color: theme.palette.primary.main,
      },
    },
    "& .button-custom": {
      padding: "24px 40px",
      fontSize: "18px",
      marginTop: "30px",
      color: "#FFF",
      backgroundColor: "#8721aa",

      [theme.breakpoints.down("xl")]: {
        padding: "20px 28px",
        fontSize: "14px",
      },

      [theme.breakpoints.down("md")]: {
        margin: "40px auto",
        display: "block",
        padding: "18px 26px",
        fontSize: "14px",
      },
    },
    "& .bgimg": {
      float: "right",
      width: "15%",
      height: "15%",
      backgroundSize: "cover",
      backgroundPosition: "50% 50%",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",

      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    "& .content-padding": {
      paddingTop: "8rem",
    }
  },
}));
